<template>
  <a-drawer title="查询优惠券激活码" :visible="visible" :width="900" @close="close" destroyOnClose>
    <a-form layout="inline">
      <a-form-item label="领取状态">
        <a-select v-model="queryParam.receiveStatus" style="width: 100px">
          <a-select-option :value="null">全部</a-select-option>
          <a-select-option :value="0">未领取</a-select-option>
          <a-select-option :value="1">已领取</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="激活码状态">
        <a-select v-model="queryParam.status" style="width: 100px">
          <a-select-option :value="null">全部</a-select-option>
          <a-select-option :value="0">有效</a-select-option>
          <a-select-option :value="1">失效</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="handleQuery">查询</a-button>
        <a-button style="margin-left: 8px" @click="resetQuery">重置</a-button>
      </a-form-item>
    </a-form>

    <a-table
      style="margin-top: 16px"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <span slot="receiveStatus" slot-scope="text">
        {{ text === 0 ? '未领取' : '已领取' }}
      </span>
      <span slot="status" slot-scope="text">
        {{ text === 0 ? '有效' : '失效' }}
      </span>

      <span slot="action" slot-scope="text, record">

        <a v-hasPermi="['coupon:activation:remove']" @click="handleDelete(record)">删除</a>
      </span>
    </a-table>
  </a-drawer>
</template>

<script>
import { listCode, deleteCode } from '@/api/coupon/controller/index.js'

export default {
  data() {
    return {
      visible: false,
      couponId: null,
      loading: false,
      list: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        receiveStatus: null,
        status: null,
        sortField: '',
        sortOrder: '',
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
      },
      columns: [
        { title: '激活码', dataIndex: 'code', align: 'center', width: 150 },
        {
          title: '领取状态',
          dataIndex: 'receiveStatus',
          scopedSlots: { customRender: 'receiveStatus' },
          align: 'center',
        },
        { title: '激活码状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: '领取用户', dataIndex: 'userName', align: 'center' },
        { title: '插入时间', dataIndex: 'createTime', sorter: true, align: 'center' },
        {
          title: '操作',
          align: 'center',
          width: 80,
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  methods: {

     handleDelete(row) {
      var that = this
      let ids = []
      const postIds = row.id || this.ids
      if (row.id) {
        ids = [{ id: postIds }]
      } else {
        postIds.forEach((v) => {
          ids.push({ id: v })
        })
      }

      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return deleteCode(ids).then(() => {
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    open(couponId) {
      this.couponId = couponId
      this.visible = true
      this.getList()
    },
    close() {
      this.visible = false
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        receiveStatus: null,
        status: null,
        sortField: '',
        sortOrder: '',
      }
    },
    getList() {
      this.loading = true
      listCode({ ...this.queryParam, couponId: this.couponId }).then((res) => {
        const { records, current, total, size } = res.data
        this.list = records
        this.pagination.current = current
        this.pagination.total = total
        this.pagination.pageSize = size
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        receiveStatus: null,
        status: null,
        sortField: '',
        sortOrder: '',
      }
      this.getList()
    },
    handleTableChange(p, f, s) {
      this.queryParam.pageNum = p.current
      this.queryParam.pageSize = p.pageSize
      if (s.order) {
        this.queryParam.sortField = s.columnKey
        this.queryParam.sortOrder = s.order === 'ascend' ? 'ASCEND' : 'DESCEND'
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
      }
      this.getList()
    },
  },
}
</script>

<style scoped></style>
